import { getComments } from "../../Utils/getCommets";
import { getPastReferencesList } from "../../Utils/recurrenceReferences";

export const updateContextPostmortemState = (
  currentPostmortemObject,
  memoizedDispatch,
  setOriginalPostmortemState
) => {
  memoizedDispatch({
    type: "HANDLE EDITOR CHANGE",
    field: "incidentSummaryState",
    payload: {
      incSummDescription: currentPostmortemObject.incident_summary
        ? currentPostmortemObject.incident_summary.incidentSummary
        : "",
      preceEventsDescription: currentPostmortemObject.precedingEvents
        ? currentPostmortemObject.precedingEvents.description
        : "",
      impact: currentPostmortemObject.businessImpact
        ? currentPostmortemObject.businessImpact.description
        : "",
      detectionAndResponseDescription: currentPostmortemObject.detectionResponse
        ? currentPostmortemObject.detectionResponse.description
        : "",
      mttd: currentPostmortemObject.detectionResponse
        ? currentPostmortemObject.detectionResponse.mttd
        : "",
      mttrespond: currentPostmortemObject.detectionResponse
        ? currentPostmortemObject.detectionResponse.mttrespond
        : "",
      mttrepair: currentPostmortemObject.detectionResponse
        ? currentPostmortemObject.detectionResponse.mttrepair
        : "",
      mttrecover: currentPostmortemObject.detectionResponse
        ? currentPostmortemObject.detectionResponse.mttrecover
        : "",
      comments: currentPostmortemObject.incident_summary
        ? getComments(currentPostmortemObject.incident_summary.comments)
        : { NEW: [], INREVIEW: [], DONE: [] },
      isCustomMttrepair: false,
    },
  });

  memoizedDispatch({
    type: "HANDLE EDITOR CHANGE",
    field: "postmortemIsIncompleteState",
    payload: {
      incomplete: currentPostmortemObject.postMortemIncomplete
        ? currentPostmortemObject.postMortemIncomplete
        : false,
    },
  });

  const questions =
    currentPostmortemObject &&
    currentPostmortemObject.rootCauseIdentificationRequest &&
    Array.isArray(
      currentPostmortemObject.rootCauseIdentificationRequest.questionarie
    )
      ? currentPostmortemObject.rootCauseIdentificationRequest.questionarie.map(
          (question, index) => {
            if (question) {
              return {
                [`question`]: question.question,
                [`answer`]: question.answer,
              };
            } else {
              return {
                [`question`]: "",
                [`answer`]: "",
              };
            }
          }
        )
      : [];
  // [`question${i + 1}`]

  const firstAuditLog =
    currentPostmortemObject && currentPostmortemObject.auditLogs
      ? currentPostmortemObject.auditLogs.find((log) => log.sequenceNo === "0001")
      : null;
  const hasAIBaseline = firstAuditLog && firstAuditLog.updatedBy === "Postmortem-AI";

  memoizedDispatch({
    type: "HANDLE EDITOR CHANGE",
    field: "RootCauseIdentificationState",

    payload: {
      description: hasAIBaseline ? "" : currentPostmortemObject.rootCauseIdentificationRequest
        ? currentPostmortemObject.rootCauseIdentificationRequest.description
        : "",
      questions: hasAIBaseline ? [] : [...questions],
    },
  });

  memoizedDispatch({
    type: "HANDLE EDITOR CHANGE",
    field: "RecurrenceState",

    payload: {
      recurrence: currentPostmortemObject.recurrence
        ? currentPostmortemObject.recurrence.recurrence
        : "",
      // count: "",
      incidentId: currentPostmortemObject?.recurrence?.pastReferences?.incidentId ?? "",
      problemId: currentPostmortemObject?.recurrence?.pastReferences?.problemId ?? "",
      description: currentPostmortemObject?.recurrence?.pastReferences?.description ?? "",
      pastReferencesList: getPastReferencesList(currentPostmortemObject?.recurrence),

      recurringIssue: currentPostmortemObject?.recurrence?.recurringIssue === true ||
        currentPostmortemObject?.recurrence?.recurringIssue === "true",
    },
  });
  memoizedDispatch({
    type: "HANDLE EDITOR CHANGE",
    field: "RootCauseState",

    payload: {
      cause: hasAIBaseline ? "" : currentPostmortemObject.rootCause
        ? currentPostmortemObject.rootCause.cause
        : "",
      rootCauseCode: hasAIBaseline ? "" : currentPostmortemObject.rootCause
        ? currentPostmortemObject.rootCause.rootCauseCode
        : "",
      rootCauseSubCode: hasAIBaseline ? "" : currentPostmortemObject.rootCause
        ? currentPostmortemObject.rootCause.rootCauseSubCode
        : "",
      impactedByChange: hasAIBaseline ? false : currentPostmortemObject.rootCause
        ? currentPostmortemObject.rootCause.impactedByChange
          ? currentPostmortemObject.rootCause.impactedByChange === "true" ||
            currentPostmortemObject.rootCause.impactedByChange === true
          : false
        : false,

      causedByChangeNumber: hasAIBaseline ? "" : currentPostmortemObject.rootCause
        ? currentPostmortemObject.rootCause.causedByChangeNumber
        : "",

      causedByVendor: hasAIBaseline ? "" : currentPostmortemObject.rootCause
        ? currentPostmortemObject.rootCause.causedByVendor
        : "",
      vendorDetails: hasAIBaseline ? "" : currentPostmortemObject.rootCause
        ? currentPostmortemObject.rootCause.vendorOptions
          ? currentPostmortemObject.rootCause.vendorOptions
          : ""
        : "",
      comments: hasAIBaseline
        ? { NEW: [], INREVIEW: [], DONE: [] }
        : currentPostmortemObject.rootCause
        ? getComments(currentPostmortemObject.rootCause.comments)
        : { NEW: [], INREVIEW: [], DONE: [] },
      tags: hasAIBaseline
        ? []
        : currentPostmortemObject.rootCause
        ? currentPostmortemObject.rootCause.tags
          ? [...currentPostmortemObject.rootCause.tags]
          : []
        : [],
    },
  });

  memoizedDispatch({
    type: "HANDLE EDITOR CHANGE",
    field: "PreventiveAndCorrectiveMeasuresState",

    payload: {
      pTasks: currentPostmortemObject.preventiveCorrectiveMeasures
        ? getPatsks(currentPostmortemObject?.preventiveCorrectiveMeasures)
        : [],
      jiraTickets: currentPostmortemObject.preventiveCorrectiveMeasures
        ? getJiraTickets(currentPostmortemObject.preventiveCorrectiveMeasures)
        : [],
      comments: currentPostmortemObject.preventiveCorrectiveMeasures
        ? getComments(
            currentPostmortemObject.preventiveCorrectiveMeasures[0].comments,
            "PCM"
          )
        : { NEW: [], INREVIEW: [], DONE: [] },
      trackingMethod: "Jira",
      recommendedActions: currentPostmortemObject.recommendedActions,
    },
  });

  memoizedDispatch({
    type: "HANDLE EDITOR CHANGE",
    field: "postmortemCurrentStatus",

    payload: {
      currentState: currentPostmortemObject.status
        ? currentPostmortemObject.status
        : "NEW",
    },
  });

  memoizedDispatch({
    type: "HANDLE EDITOR CHANGE",
    field: "DetectionResponseState",
    payload: {
      description: currentPostmortemObject.detectionResponse
        ? currentPostmortemObject.detectionResponse.description
        : "",
      mttd: currentPostmortemObject.detectionResponse
        ? currentPostmortemObject.detectionResponse.mttd
        : "",
      mttrespond: currentPostmortemObject.detectionResponse
        ? currentPostmortemObject.detectionResponse.mttrespond
        : "",
      mttrepair: currentPostmortemObject.detectionResponse
        ? currentPostmortemObject.detectionResponse.mttrepair
        : "",
      mttrecover: currentPostmortemObject.detectionResponse
        ? currentPostmortemObject.detectionResponse.mttrecover
        : "",
    },
  });

  memoizedDispatch({
    type: "HANDLE EDITOR CHANGE",
    field: "RecoveryState",
    payload: {
      recovery: hasAIBaseline ? "" : currentPostmortemObject.recovery
        ? currentPostmortemObject.recovery.recovery
          ? currentPostmortemObject.recovery.recovery
          : ""
        : "",
    },
  });

  memoizedDispatch({
    type: "HANDLE EDITOR CHANGE",
    field: "lockedFields",
    payload: currentPostmortemObject.lockedFields
      ? currentPostmortemObject.lockedFields
      : [],
  });

  memoizedDispatch({
    type: "HANDLE EDITOR CHANGE",
    field: "recommendedKPIs",
    payload: {
      mttd: currentPostmortemObject.recommendedKPIs
        ? currentPostmortemObject.recommendedKPIs.mttd
        : "",
      mttrespond: currentPostmortemObject.recommendedKPIs
        ? currentPostmortemObject.recommendedKPIs.mttrespond
        : "",
    },
  });

  setOriginalPostmortemState((currState) => {
    return {
      ...currState,

      rootCauseState: {
        cause: hasAIBaseline ? "" : currentPostmortemObject.rootCause
          ? currentPostmortemObject.rootCause.cause
          : "",
        rootCauseCode: hasAIBaseline ? "" : currentPostmortemObject.rootCause
          ? currentPostmortemObject.rootCause.rootCauseCode
          : "",
        rootCauseSubCode: hasAIBaseline ? "" : currentPostmortemObject.rootCause
          ? currentPostmortemObject.rootCause.rootCauseSubCode
          : "",
        impactedByChange: hasAIBaseline ? false : currentPostmortemObject.rootCause
          ? currentPostmortemObject.rootCause.impactedByChange
            ? currentPostmortemObject.rootCause.impactedByChange === "true" ||
              currentPostmortemObject.rootCause.impactedByChange === true
            : false
          : false,

        causedByChangeNumber: hasAIBaseline ? "" : currentPostmortemObject.rootCause
          ? currentPostmortemObject.rootCause.causedByChangeNumber
          : "",

        causedByVendor: hasAIBaseline ? "" : currentPostmortemObject.rootCause
          ? currentPostmortemObject.rootCause.causedByVendor
          : "",
        vendorDetails: hasAIBaseline ? "" : currentPostmortemObject.rootCause
          ? currentPostmortemObject.rootCause.vendorOptions
            ? currentPostmortemObject.rootCause.vendorOptions
            : ""
          : "",
        comments: hasAIBaseline
          ? { NEW: [], INREVIEW: [], DONE: [] }
          : currentPostmortemObject.rootCause
          ? getComments(currentPostmortemObject.rootCause.comments)
          : { NEW: [], INREVIEW: [], DONE: [] },
        tags: hasAIBaseline
          ? []
          : currentPostmortemObject.rootCause
          ? currentPostmortemObject.rootCause.tags
            ? [...currentPostmortemObject.rootCause.tags]
            : []
          : [],
      },

      preventiveAndCorrectiveMeasuresState: {
        pTasks: currentPostmortemObject.preventiveCorrectiveMeasures
          ? getPatsks(currentPostmortemObject?.preventiveCorrectiveMeasures)
          : [],
        jiraTickets: currentPostmortemObject.preventiveCorrectiveMeasures
          ? getJiraTickets(currentPostmortemObject.preventiveCorrectiveMeasures)
          : [],
        comments: currentPostmortemObject.preventiveCorrectiveMeasures
          ? getComments(
              currentPostmortemObject.preventiveCorrectiveMeasures[0].comments,
              "PCM"
            )
          : { NEW: [], INREVIEW: [], DONE: [] },
        recommendedActions: currentPostmortemObject.recommendedActions,
        trackingMethod: "Jira",
      },

      postmortemCurrentStatus: {
        currentState: currentPostmortemObject.status
          ? currentPostmortemObject.status
          : "NEW",
      },

      detectionResponseState: {
        description: currentPostmortemObject.detectionResponse
          ? currentPostmortemObject.detectionResponse.description
          : "",
        mttd: currentPostmortemObject.detectionResponse
          ? currentPostmortemObject.detectionResponse.mttd
          : "",
        mttrespond: currentPostmortemObject.detectionResponse
          ? currentPostmortemObject.detectionResponse.mttrespond
          : "",
        mttrepair: currentPostmortemObject.detectionResponse
          ? currentPostmortemObject.detectionResponse.mttrepair
          : "",
        mttrecover: currentPostmortemObject.detectionResponse
          ? currentPostmortemObject.detectionResponse.mttrecover
          : "",
      },

      incidentSummaryState: {
        incSummDescription: currentPostmortemObject.incident_summary
          ? currentPostmortemObject.incident_summary.incidentSummary
          : "",
        preceEventsDescription: currentPostmortemObject.precedingEvents
          ? currentPostmortemObject.precedingEvents.description
          : "",
        impact: currentPostmortemObject.businessImpact
          ? currentPostmortemObject.businessImpact.description
          : "",
        detectionAndResponseDescription:
          currentPostmortemObject.detectionResponse
            ? currentPostmortemObject.detectionResponse.description
            : "",
        mttd: currentPostmortemObject.detectionResponse
          ? currentPostmortemObject.detectionResponse.mttd
          : "",
        mttrespond: currentPostmortemObject.detectionResponse
          ? currentPostmortemObject.detectionResponse.mttrespond
          : "",
        mttrepair: currentPostmortemObject.detectionResponse
          ? currentPostmortemObject.detectionResponse.mttrepair
          : "",
        mttrecover: currentPostmortemObject.detectionResponse
          ? currentPostmortemObject.detectionResponse.mttrecover
          : "",
        comments: currentPostmortemObject.incident_summary
          ? getComments(currentPostmortemObject.incident_summary.comments)
          : { NEW: [], INREVIEW: [], DONE: [] },
      },
      rootCauseIdentificationState: {
        description: currentPostmortemObject.rootCauseIdentificationRequest
          ? currentPostmortemObject.rootCauseIdentificationRequest.description
          : "",
        questions: [...questions],
      },
      recurrenceState: {
        recurrence: currentPostmortemObject.recurrence
          ? currentPostmortemObject.recurrence.recurrence
          : "",
        // count: "",
        incidentId: currentPostmortemObject?.recurrence?.pastReferences?.incidentId ?? "",
        problemId: currentPostmortemObject?.recurrence?.pastReferences?.problemId ?? "",
        description: currentPostmortemObject?.recurrence?.pastReferences?.description ?? "",
        recurringIssue: currentPostmortemObject?.recurrence?.recurringIssue === true ||
          currentPostmortemObject?.recurrence?.recurringIssue === "true",
      },
    };
  });
};

// Helper function to format email to name (e.g., "ivana.stasinszka@maersk.com" -> "Ivana Stasinszka")
const formatEmailToName = (email) => {
  if (!email || typeof email !== 'string') return email;
  
  // Extract the part before @ symbol
  const namePart = email.split('@')[0];
  
  // Replace dots with spaces and capitalize each word
  const formattedName = namePart
    .split('.')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
  
  return formattedName;
};

const getPatsks = (data) => {
  let pTasks = [];

  if (data && data.length > 0 && data[0].ptask) {
    pTasks = data[0].ptask.map((ptask) => ({
      link: ptask.link,
      ptaskid: ptask.ptaskid,
      description: ptask.description, // Fixed the typo "decription" to "description"
      type: ptask.type,
      eta: ptask.eta,
      owners: [...ptask.owners],
      assignee: formatEmailToName(ptask.assignee), // Format email to name
      assignment_group: ptask.assignment_group,
      status: ptask.status,
      platformPortfolio: ptask.platformPortfolio ? ptask.platformPortfolio : "",
      actionCategory: ptask.actionCategory ? ptask.actionCategory : [],
      horizontalVerticalFix: ptask.horizontalVerticalFix ? ptask.horizontalVerticalFix : null,
      ptaskPlatform: ptask.ptaskPlatform || null,
      ptaskProduct: ptask.ptaskProduct || null,
    }));
  }

  return pTasks.length > 0 ? pTasks : [];
};

const getJiraTickets = (data) => {
  let jiraTickets = [];

  if (data && data.length > 0 && data[0].jira) {
    jiraTickets = data[0].jira.map((jir) => ({
      jiraid: jir.jiraid,
      description: jir.description,
      ETA: jir.ETA,
      duedate: jir.duedate,
      owners: jir.owners ? [...jir.owners] : [],
      assignee: formatEmailToName(jir.assignee),
      status: jir.status,
      platformPortfolio: jir.platformPortfolio ? jir.platformPortfolio : "",
      actionCategory: jir.actionCategory ? jir.actionCategory : [],
      horizontalVerticalFix: jir.horizontalVerticalFix ? jir.horizontalVerticalFix : null,
      jiraPlatform: jir.jiraPlatform || null,
      jiraProduct: jir.jiraProduct || null,
    }));
  }

  return jiraTickets.length > 0 ? jiraTickets : [];
};

export const updateContextWithWebSocketData = (
  changedFields,
  currentPostmortemState,
  memoizedDispatch
) => {
  changedFields = JSON.parse(changedFields);

  let updatedPostmortemState = { ...currentPostmortemState };

  for (let i = 0; i < changedFields.length; i++) {
    let field = changedFields[i];

    if (field.fieldName === "jiraTickets") {
      updatedPostmortemState[field.parentField][field.fieldName] = [
        ...getJiraTickets(field.content),
      ];
    } else if (field.fieldName === "pTasks") {
      updatedPostmortemState[field.parentField][field.fieldName] = [
        ...getPatsks(field.content),
      ];
    } else {
      updatedPostmortemState[field.parentField][field.fieldName] =
        field.content;
    }

    // Preserve existing changedFields state when updating from WebSocket
    const currentStateForField = currentPostmortemState[field.parentField];
    const existingChangedFields =
      currentStateForField?.changedFileds ||
      currentStateForField?.changedFields ||
      {};

    memoizedDispatch({
      type: "HANDLE EDITOR CHANGE",
      field: field.parentField,
      payload: {
        ...updatedPostmortemState[field.parentField],
        // Preserve local changedFields state by merging with WebSocket updates
        changedFileds: {
          ...existingChangedFields,
          // Only override the specific field that was updated via WebSocket if it wasn't locally changed
          ...(existingChangedFields[field.fieldName]
            ? {}
            : { [field.fieldName]: false }),
        },
        // Also handle the typo variant for backward compatibility
        changedFields: {
          ...existingChangedFields,
          ...(existingChangedFields[field.fieldName]
            ? {}
            : { [field.fieldName]: false }),
        },
      },
    });
  }
};
